import { FC, useState } from 'react';

import { useCompanyHolders } from 'hooks';
import { OfficeholderType } from 'types';

import {
  Alert,
  Button,
  FormattedMessage,
  List,
  Row,
  StepButtons,
} from 'components';

import * as duck from '../../duck';
import { OfficeholdersTable, RemoveIcon, StepInstructions } from '../shared';
import { AddNewDrawer } from './components';

interface OfficeholdersProps extends duck.Types.StepProps {
  cognitoID: string;
}

const Officeholders: FC<OfficeholdersProps> = ({
  company,
  cognitoID,
  ...props
}) => {
  const [drawerOpen, toggleDrawerOpen] = useState(false);
  const { data, isLoading, queryKey } = useCompanyHolders({
    companyID: company.id,
    cognitoID,
    subRoute: 'officeholders',
  });

  const noDirectors = !data.filter(
    (item) => item.typeID === OfficeholderType.Director,
  ).length;

  const noPublicOfficer = !data.some(
    (item) => item.typeID === OfficeholderType.PublicOfficer,
  );

  return (
    <>
      <AddNewDrawer
        cognitoID={cognitoID}
        officeholders={data}
        companyID={company.id}
        open={drawerOpen}
        onClose={() => toggleDrawerOpen(false)}
        queryKey={queryKey}
      />
      <StepInstructions
        currentStep={props.currentStep}
        title='company.thirdStep.title'
        description='company.thirdStep.description'
      />
      <Row justify='end' style={{ marginBottom: 14 }}>
        <Button type='primary' onClick={() => toggleDrawerOpen(true)}>
          Add Officeholder
        </Button>
      </Row>
      <OfficeholdersTable
        isLoading={isLoading}
        data={data}
        actionsColumn={[
          {
            title: 'common.actions',
            dataIndex: 'id',
            render: ({ value }: any) => (
              <RemoveIcon
                cognitoID={cognitoID}
                companyID={company.id}
                itemID={value}
                subRoute='officeholders'
                queryKeys={[queryKey]}
              />
            ),
          },
        ]}
      />
      <List
        size='small'
        dataSource={[
          {
            title: 'company.thirdStep.oneOrMoreDirector',
            valid: !noDirectors,
          },
          {
            title: 'company.thirdStep.zeroOrOneSecretary',
            valid: true,
          },
          {
            title: 'company.thirdStep.onePublicOfficer',
            valid: !noPublicOfficer,
          },
        ]}
        renderItem={({ title, valid }) => (
          <List.Item>
            <Alert
              type={valid ? 'success' : 'error'}
              message={<FormattedMessage id={title} />}
            />
          </List.Item>
        )}
      />
      <StepButtons
        {...props}
        nextDisabled={isLoading || noDirectors || noPublicOfficer}
      />
    </>
  );
};

export default Officeholders;
